import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import StockTransferList from "./lists/stocktransferList";
import StockTransferForm from "./forms/stocktransferForm";
import {postData} from "../../utils/request";
import Modal from "../layout/Modal";
import isEqual from "lodash-es/isEqual";
import BoxEditor from "./BoxEditor";
import ModalEditor from "./ModalEditor";
import shippingEditor from "./shippingEditor";
import Button from "../form/Button";
import StoreOrderEditor from "./storeorder/storeorderEditor";
import {loadComponent} from "../../utils/components";
import ContentLoader from "../layout/ContentLoader";
import connect from "react-redux/es/connect/connect";
import StoreOrderClaimEditor from "./StoreOrderClaimEditor";
import ShippingEditor from "./shippingEditor";

const stateConst = {
    TransferInitiated: 0,
    Modification: 50,
    UnderRevision: 100,
    MissingStock: 107,
    WaitingForStock: 110,
    StockReserved: 120,
    OriginStoreOrderDelete: 130,
    OriginStoreOrderSent: 200,
    OriginStoreOrderClaim: 210,
    OriginStoreOrderCompleted: 220,
    ShippingOrdered: 300,
    ShippingFailed: 310,
    ShippingCompleted: 320,
    DestinationStoreOrderSent: 400,
    DestinationStoreOrderClaim: 410,
    DestinationStoreOrderCompleted: 420,
    UnderClaimOld: 500,
    ClaimProcessed: 505,
    TransferProcessed: 510,
    UnderClaim: 511,
    TransferCompleted: 520,
    DeleteTransferInitiated: 900,
    DeleteStockReserved: 910,
    DeleteStoreOrderSent: 920,
    DeleteStoreOrderClaim: 930,
    DeleteStoreOrderCompleted: 940,
    WaitingForDeletePayment: 950,
    DeleteProcessed: 960,
    Deleted: 990,
};

const stateType = {};
Object.keys(stateConst).forEach((key) => {
    stateType[key] = state => state + "" === stateConst[key] + ""
});

class stocktransferEditor extends React.Component {

    stateButtons = (state) => {
        return {
            [stateConst.MissingStock + ""]: "Várakoztatás",
            [stateConst.OriginStoreOrderCompleted + ""]: "Szállítás újra rendelése"
        }[state + ""] || "Mehet";
    };

    stateButtonEnabled = (state) => [
        stateType.TransferInitiated,
        stateType.Modification,
        stateType.UnderRevision,
        stateType.MissingStock,
        stateType.WaitingForStock,
        stateType.StockReserved,
        stateType.OriginStoreOrderClaim,
        stateType.OriginStoreOrderCompleted,
        stateType.ShippingFailed,
        stateType.ShippingCompleted,
        stateType.DestinationStoreOrderClaim,
        stateType.DestinationStoreOrderCompleted,
        stateType.UnderClaimOld,
        stateType.TransferProcessed,
    ].filter((f) => f(state)).length;

    state = {
        modifyStock: false
    };

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.values[prevProps.componentConfig.idfield], this.props.values[this.props.componentConfig.idfield]) && this.state.modifyStock !== false) {
            this.setState({modifyStock: false});
        }
    }

    setFieldValue = (field, value) => {
        this.props.setFieldValue(field, value);
    }

    proceedState = async () => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.proceedState',
                data: values
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    modifyAction = async () => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.modifyAction',
                data: values
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    modifyStock = async () => {
        if (!this.state.modifyStock) {
            this.setState({modifyStock: true});
            return;
        }
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.proceedState',
                data: values,
                modify_stock: true
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            this.setState({modifyStock: false});
            return response;
        });
    }

    render() {
        const isEditable =
            parseInt(this.props.values.state + "") <= 200
            && !stateType.Modification(this.props.values.state);

        const ShippingEditor = shippingEditor;

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const actionButtons = [];
        if (stateType.MissingStock(this.props.values.state)) {
            actionButtons.push(
                <Fragment key="8">
                    <Modal
                        state={this.state.modifyStock ? "on" : "off"}
                        theme="default"
                        header="Biztos mehet?"
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({modifyStock: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Mehet',
                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                                onClick: async () => {
                                    this.modifyStock();
                                }
                            }
                        ]}
                    >
                        Biztos elengeded? A hiányban lévő tételek módosításra kerülnek!
                    </Modal>
                    <Button
                        key="3"
                        disabled={this.props.isLoading || !this.stateButtonEnabled(this.props.values.state)}
                        color="primary"
                        className="pull-right"
                        onClick={this.modifyStock}
                    >
                        Mehet
                    </Button>
                </Fragment>
            );
        }
        actionButtons.push(
            <Button
                key="1"
                disabled={this.props.isLoading || !this.stateButtonEnabled(this.props.values.state)}
                color="primary"
                className="pull-right"
                onClick={this.proceedState}
            >
                {this.stateButtons(this.props.values.state)}
            </Button>
        );
        if (isEditable) {
            actionButtons.push(
                <Button
                    key="2"
                    disabled={this.props.isLoading}
                    color="warning"
                    className="pull-right"
                    onClick={this.modifyAction}
                >
                    Módosítás
                </Button>
            );
        }
        actionButtons.push(
            <Button
                key="3"
                disabled={!this.props.values[this.props.componentConfig.idfield] || !this.stateButtonEnabled(this.props.values.state) || this.props.isLoading}
                color="danger"
                onClick={this.props.deleteForm}
            >
                Törlés
            </Button>
        );

        return (
            <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Szállítás lista"}
                >
                    <StockTransferList ref={(el) => this.list = el} {...this.props} />
                </List>
                {this.props.values[this.props.componentConfig.idfield] && <Editor
                    {...this.props}
                    theme="default"
                    header={"Szállítás adatai"}
                    footer={actionButtons}
                >
                    <StockTransferForm
                        stateConst={stateConst}
                        stateType={stateType}
                        ref={(form) => this.form = form}
                        {...this.props}
                    />
                </Editor>}
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    (this.props.values.origin || {}).id !== (this.props.values.destination || {}).id
                    &&
                    <Fragment>
                        <StoreOrderEditor
                            editorContext="stocktransferStoreOrderEditorOut"
                            collapsed={!(parseInt(this.props.values.state + "") >= 200 && parseInt(this.props.values.state + "") <= 220)}
                            out={true}
                            client={this.props}
                            listFilter={[
                                {
                                    field: "client_component",
                                    value: this.props.componentConfig.componentname
                                },{
                                    field: "client_component_id",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }
                            ]}
                            editor={ModalEditor}
                            selection={null}
                            onProcessAction={() => {
                                if (!this.props.isLoading) {
                                    this.props.reloadForm && this.props.reloadForm();
                                }
                            }}
                        />
                        <ShippingEditor
                            editorContext="stocktransferShippingEditor"
                            gridid="stocktransferShippingList"
                            pageSize={0}
                            presets={{
                                client_component: this.props.componentConfig.componentname,
                                client_component_type: this.props.componentConfig.componentname,
                                client_component_id: this.props.values[this.props.componentConfig.idfield],
                            }}
                            collapsed={!(parseInt(this.props.values.state + "") >= 220 && parseInt(this.props.values.state + "") < 400)}
                            editor={ModalEditor}
                            businessComponent={this.props}
                            disable={!(stateType.ShippingFailed(this.props.values.state) || stateType.OriginStoreOrderCompleted(this.props.values.state))}
                            selection={null}
                            saveForm={async () => {
                                this.props.reloadForm && this.props.reloadForm();
                            }}
                            onProcessAction={() => {
                                if (!this.props.isLoading) {
                                    this.props.reloadForm && this.props.reloadForm();
                                }
                            }}
                        />
                        <StoreOrderEditor
                            editorContext="stocktransferStoreOrderEditorIn"
                            collapsed={!(parseInt(this.props.values.state + "") >= 400 && parseInt(this.props.values.state + "") <= 420)}
                            in={true}
                            client={this.props}
                            listFilter={[
                                {
                                    field: "client_component",
                                    value: this.props.componentConfig.componentname
                                },{
                                    field: "client_component_id",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }
                            ]}
                            editor={ModalEditor}
                            selection={null}
                            onProcessAction={() => {
                                if (!this.props.isLoading) {
                                    this.props.reloadForm && this.props.reloadForm();
                                }
                            }}
                        />
                        <StoreOrderClaimEditor
                            editorContext="stocktransferStoreOrderClaimEditor"
                            collapsed={true}
                            client={this.props}
                            newButton={stateType.TransferCompleted(this.props.values.state)}
                            listFilter={[
                                {
                                    field: "client_component_type",
                                    value: this.props.componentConfig.componentname
                                },
                                {
                                    field: "client_component_id",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }
                            ]}
                            editor={ModalEditor}
                            selection={null}
                            onProcessAction={() => {
                                if (!this.props.isLoading) {
                                    this.props.reloadForm && this.props.reloadForm();
                                }
                            }}
                        />
                    </Fragment>
                }
            </Fragment>
        );
    }
}

const StockTransferEditor = createEditor({
    componentName: "stocktransfer",
    WrappedComponent: stocktransferEditor,
    props: {
        view: "admin"
    }
});

class ConsignmentStockTransfer extends React.Component {

    state = {
        stores: [],
        loading: true
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (((this.props.pos || {}).partner || {}).partner_id !== ((prevProps.pos || {}).partner || {}).partner_id) {
            this.loadStores();
        }
    }

    componentDidMount() {
        this.loadStores();
    }

    loadStores = () => {
        if (((this.props.pos || {}).partner || {}).partner_id) {
            this.setState({loading: true}, () => {
                this.allStore && this.allStore.abort();
                this.allStore = loadComponent("componentlist", {
                    component: "location",
                    itemsperpage: 0,
                    view: ["id"],
                    filter: [{field: "partner", value: this.props.pos.partner.partner_id}]
                });
                this.allStore.then((list) => {
                    this.setState({stores: list.items, loading: false});
                });
            });
        } else {
            this.setState({stores: [], loading: false});
        }
    }

    render() {
        if (!this.state.stores.length || this.state.loading) {
            return <ContentLoader/>
        }
        let {filter} = this.props;
        if (!filter) {
            filter = [];
        } else {
            if (Array.isArray(filter)) {
                filter = [...filter];
            } else if (!filter) {
                filter = [filter];
            }
        }
        filter.push({field: "destination", value: this.state.stores.map((store) => store.id), operator: "in"});
        filter.push({field: "origin", operator: "isnull"});
        return (
            <StockTransferEditor {...this.props} listFilter={filter} partnerType="consignor"/>
        );
    }
}

export const ConsignmentStockTransferEditor = connect((state) => {
    return {
        pos: (state.app.till || {}).pos || {},
    };
}, {})((props) => {
    return <ConsignmentStockTransfer {...props} editorContext="ConsignmentStockTransfer"/>;
});


export default StockTransferEditor;
